import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/EditSharp';
import { useIntl } from 'react-intl';
import { useHasPermission } from '~/modules/common/permissions';
import { USER_PERMISSION, USER_DAL } from '~/modules/common/enums';
import { useDialogState } from '~/modules/common/hooks';
import { EditUserTimeZoneDialog } from './EditUserTimeZoneDialog';
import InfoItem from './InfoItem';

const useStyles = makeStyles(theme => ({
  editButton: {
    marginLeft: theme.spacing(1),
    padding: theme.spacing(0.5)
  }
}));

export const TimeZoneInfoItem = ({
  editable,
  userUri,
  currentTimeZone,
  ...infoItemProps
}) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const hasTimeZoneEditPermission = useHasPermission({
    actionUri: USER_PERMISSION.EDIT_TIME_ZONE,
    dataAccessLevelUri: USER_DAL.USER
  });
  const {
    open: timeZoneDialogOpen,
    openDialog: handleOpenTimeZoneDialog,
    closeDialog: handleCloseTimeZoneDialog
  } = useDialogState();

  const canEditTimeZone = hasTimeZoneEditPermission && editable;

  return (
    <InfoItem {...infoItemProps}>
      {canEditTimeZone && (
        <IconButton
          size="small"
          aria-label={`${formatMessage({
            id: 'resourceBasicInfoCard.edit'
          })} ${formatMessage({ id: 'resourceBasicInfoCard.timeZone' })}`}
          onClick={handleOpenTimeZoneDialog}
          className={classes.editButton}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      )}
      {canEditTimeZone && (
        <EditUserTimeZoneDialog
          open={timeZoneDialogOpen}
          onClose={handleCloseTimeZoneDialog}
          userUri={userUri}
          currentTimeZone={currentTimeZone}
        />
      )}
    </InfoItem>
  );
};

TimeZoneInfoItem.propTypes = {
  editable: PropTypes.bool,
  userUri: PropTypes.string,
  currentTimeZone: PropTypes.shape({
    id: PropTypes.string,
    displayText: PropTypes.string
  })
};
